<template>

  <DashboardLayout :menu-items="dashboardMenu">
    <div class="my-dashboard">
      <div class="row">
        <img class="profile-fixed text-right rounded rounded-circle"
             :src="require('@/assets/avatar.jpg')"
             alt="پروفایل">
        <!--    todo: add notification and wallet     -->
        <!--        <div class="col-8 col-sm-10 col-lg-9 pt-3 ml-0 inventory text-left">

                  <span>
                                   <b-icon class="bell-big text-right" icon="bell" href="#"></b-icon>
                                     <span class='badge badge-warning' id='lblCartCount'> 1 </span>
                                 </span>
                  موجودی:۲۰۰۰ تومان
                </div>-->
      </div>
    </div>
    <div class="text-dashboard mt-5 w-100 h-auto">
      <router-view name="dashboard"/>
    </div>

  </DashboardLayout>
</template>

<script>
import {mapActions} from 'vuex'
import DashboardLayout from '../../components/dashboard/Layout'
import {dashboardMenu} from '../../routes/DashboardRoutes'

export default {
  name: "DashboardTemplate",
  components: {DashboardLayout},
  data() {
    return {
      dashboardMenu
    }
  },
  methods: {
    ...mapActions({
      logout: "Authentication/logout"
    })
  }

};
</script>

<style>
.b-toaster {
  z-index: 9999999 !important;
}
</style>


<style scoped>
.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
  padding: 10px;
}

.inventory {
  font-size: 80%;
}

.my-dashboard {
  width: 100%;
  height: 70px;
  background: white;
  border-radius: 5px;

}

.profile-fixed {
  width: 50px;
  height: 50px;
  margin-right: 50px;
  margin-top: 12px;
}

.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
}

#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: 0px;
}

.bell-big {
  width: 30px;
  height: 20px;
}


</style>